import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

import Component from './component'

const Container = props => {
  const requestSubmit = hooks.useFormFunction('requestSubmit')

  const handleSubmit = useCallback(() => requestSubmit({ forceSubmit: true }), [requestSubmit])

  const mergedProps = {
    handleSubmit,
  }

  return <Component {...mergedProps} {...props} />
}

export default Container
